import usePermission from "../../Core/hooks/usePermission";
import { PERMISSIONS } from "../Login/constants";

const useHeaderItems = () => {
  const data = [
    {
      id: 1,
      padding: "filter",
      width: "dynamic",
      text: "Commodity",
      hasPermission: usePermission([
        PERMISSIONS.RATE_VIEW,
        PERMISSIONS.RATE_VIEW_AND_EDIT,
      ]),
    },
    {
      id: 2,
      padding: "filter",
      width: "dynamic",
      text: "Energy",
      hasPermission: usePermission([
        PERMISSIONS.RATE_VIEW,
        PERMISSIONS.RATE_VIEW_AND_EDIT,
      ]),
    },
    {
      id: 3,
      padding: "filter",
      width: "dynamic",
      text: "Agri-Tech",
      hasPermission: usePermission([
        PERMISSIONS.RATE_VIEW,
        PERMISSIONS.RATE_VIEW_AND_EDIT,
      ]),
    },
  ];

  return data;
};

export default useHeaderItems;
